import control from './control'

export default {
  data: {
    name: control.name,
    control: control.name,
    parent: 0,
    id: 'k55rzi02.w4',
    value: {
      type: 'message',
      message: 'Thanks for contacting us! We will be in touch with you shortly.',
      redirectUrl: ''
    }
  },
  components: {
    control
  }
}
